import React from 'react'
import { styled, Button, Stack } from '@mui/material'
import LiveDataBar from '../components/LiveDataBar'
import LiveDataDetailedBar from '../components/LiveDataDetailedBar'

const DataBarContainer = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px'
}))

const Overview = ({ groupedData, runningTimeData }) => {
  const [isDetailedDataShown, setIsDetailedDataShown] = React.useState(false)

  return (
    <div>
      <DataBarContainer>
        <Stack
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          <p>Total Idletime:</p>
          <b>{runningTimeData.totalIdleTime} minutes</b>
          <> | </>
          <p>Total running time:</p>
          <b>{runningTimeData.totalRunningTime} minutes</b>
        </Stack>
        <LiveDataBar
          liveData={groupedData}
          width={1120}
          count={Object.values(groupedData).length}
          isBorder={true}
          runningTimeData={runningTimeData}
        />
        {/* <Button
          size="small"
          variant="outlined"
          style={{
            marginRight: 'auto',
            width: '190px'
          }}
          onClick={() => setIsDetailedDataShown((prev) => !prev)}
        >
          {isDetailedDataShown ? 'Show less' : 'Show detailed analysis'}
        </Button>
        {isDetailedDataShown && (
          <LiveDataDetailedBar liveData={groupedData} width={600} />
        )} */}
      </DataBarContainer>
    </div>
  )
}

export default Overview
